/**
 * Close/backdrop handlers for various modals.
 */
import {
  closeCloseTimeModal,
  closeEstimateModal,
  closeImagesModal,
  closeLotDetailsModal,
  closeLotModal,
  closeImageViewer,
  nextImage,
  previousImage,
} from '../../modules/ui';
import {
  isCloseTimeModalOpen,
  isEstimateModalOpen,
  isImagesModalOpen,
  isLotDetailsModalOpen,
  isModalOpen,
  isImageViewerOpen,
} from '../../modules/ui/modals';
import type { ModalHandlerDeps } from './types';

export function setupCloseHandlers(deps: ModalHandlerDeps): void {
  const { els } = deps;

  if (els.closeLotForm) {
    els.closeLotForm.addEventListener('click', () => {
      closeLotModal({ reset: true });
    });
  }

  if (els.cancelLotForm) {
    els.cancelLotForm.addEventListener('click', () => {
      closeLotModal({ reset: true });
    });
  }

  if (els.closeImagesModal) {
    els.closeImagesModal.addEventListener('click', () => {
      closeImagesModal();
    });
  }

  if (els.closeLotDetailsModal) {
    els.closeLotDetailsModal.addEventListener('click', () => {
      closeLotDetailsModal();
    });
  }

  if (els.modalBackdrop) {
    els.modalBackdrop.addEventListener('click', () => {
      if (isModalOpen()) {
        closeLotModal({ reset: true });
      }
    });
  }

  if (els.imagesModalBackdrop) {
    els.imagesModalBackdrop.addEventListener('click', () => {
      if (isImagesModalOpen()) {
        closeImagesModal();
      }
    });
  }

  if (els.lotDetailsModalBackdrop) {
    els.lotDetailsModalBackdrop.addEventListener('click', () => {
      if (isLotDetailsModalOpen()) {
        closeLotDetailsModal();
      }
    });
  }

  if (els.closeEstimateModal) {
    els.closeEstimateModal.addEventListener('click', () => {
      closeEstimateModal();
    });
  }

  if (els.estimateCancel) {
    els.estimateCancel.addEventListener('click', () => {
      closeEstimateModal();
    });
  }

  if (els.estimateModalBackdrop) {
    els.estimateModalBackdrop.addEventListener('click', () => {
      if (isEstimateModalOpen()) {
        closeEstimateModal();
      }
    });
  }

  if (els.closeCloseTimeModal) {
    els.closeCloseTimeModal.addEventListener('click', () => {
      closeCloseTimeModal();
    });
  }

  if (els.closeTimeCancel) {
    els.closeTimeCancel.addEventListener('click', () => {
      closeCloseTimeModal();
    });
  }

  if (els.closeTimeModalBackdrop) {
    els.closeTimeModalBackdrop.addEventListener('click', () => {
      if (isCloseTimeModalOpen()) {
        closeCloseTimeModal();
      }
    });
  }

  if (els.closeImageViewer) {
    els.closeImageViewer.addEventListener('click', () => {
      closeImageViewer();
    });
  }

  if (els.imageViewerBackdrop) {
    els.imageViewerBackdrop.addEventListener('click', () => {
      if (isImageViewerOpen()) {
        closeImageViewer();
      }
    });
  }

  if (els.imageViewerPrev) {
    els.imageViewerPrev.addEventListener('click', () => {
      previousImage();
    });
  }

  if (els.imageViewerNext) {
    els.imageViewerNext.addEventListener('click', () => {
      nextImage();
    });
  }
}
